import { forwardRef } from "react"

import TextInput from "../TextInput"
import { TextInputProps } from "../TextInput/TextInputProps"

const PasswordInput = (props: TextInputProps, ref: any) => {
  return <TextInput {...props} ref={ref} type="password" />
}

export default forwardRef(PasswordInput)
